import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const CheckedIcon: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
      <path d="M4.29974 7.90023L0.566406 4.16689L1.28307 3.45023L4.29974 6.46689L10.6997 0.0668945L11.4164 0.783561L4.29974 7.90023Z" fill="white" />
    </svg>
  </SvgWrapper>
);